module.exports = __webpack_public_path__ + "img/share.28301bbf.png";